import { render, staticRenderFns } from "./recruitment-norms.vue?vue&type=template&id=4da372ee&scoped=true"
var script = {}
import style0 from "./recruitment-norms.vue?vue&type=style&index=0&id=4da372ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da372ee",
  null
  
)

export default component.exports